import React, { useState, useEffect } from "react";
import { HomeWork_list, generate_token } from "../../../apis/My-e-Test/HomeWork";
import Pagination from "../../Pagination";

const Homework = () => {
  const [HomeWorkList, setHomeWorkList] = useState([]);
  const [currentPages, setCurrentPages] = useState(() => {
    if (HomeWorkList?.homeworks?.length > 0) {
      return HomeWorkList.homeworks.reduce((acc, ele) => {
        acc[ele.courseid] = 1;
        return acc;
      }, {});
    }
    return {};
  });
  const [expandedCourse, setExpandedCourse] = useState(null); // Track which course is expanded
  const state = localStorage.getItem("state");
  const sid = localStorage.getItem("sid");

  useEffect(() => {
    async function get_data() {
      const worklist = await HomeWork_list();
      setHomeWorkList(worklist?.data);
    }
    get_data();
  }, []);

  const onPageChange = (page, courseid, termid) => {
    const pageKey = `${courseid}-${termid}`;
    setCurrentPages((prevPages) => ({
      ...prevPages,
      [pageKey]: page,
    }));
  };

  const toggleCourse = (courseId) => {
    setExpandedCourse(expandedCourse === courseId ? null : courseId);
  };

  const [itemsPerPage] = useState(12);

  const onSubmit = async (data) => {
    const payload = {
      aid: data,
      state: state,
      sid: sid,
      grade: HomeWorkList?.grade,
      sto: 120,
      type: "hd_homework"
    }
    const res = await generate_token(payload);
    if (res?.status) {
      window.open(res?.data, "_blank");
    }
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="table_head">
          <h2 className="">Homework List</h2>
        </div>
        {HomeWorkList?.homeworks?.length > 0 &&
          HomeWorkList?.homeworks?.map((ele) => {
            const currentPageKey = `${ele.courseid}-${ele.termid}`;
            const currentPage = currentPages[currentPageKey] || 1;
            const startIndex = (currentPage - 1) * itemsPerPage;
            const endIndex = startIndex + itemsPerPage;

            return (
              <div key={`${ele.courseid}-${ele.termid}`} className="course-container">
                <div 
                  className="course-header" 
                  onClick={() => toggleCourse(ele.courseid)}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    backgroundColor: "#f5f5f5",
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <h3 style={{ margin: 0 }}>{ele?.course_name}</h3>
                  <span>
                    {expandedCourse === ele.courseid ? "▼" : "▶"}
                  </span>
                </div>
                
                {expandedCourse === ele.courseid && (
                  <div className="course-content">
                    <h5>
                      {ele?.year} {ele?.grade_names} - {ele?.term_name}
                    </h5>
                    <div className="table-responsive tbl_bg lectures">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col" style={{ width: "15%" }}>
                              Core Skills
                            </th>
                            {ele?.subjectdata?.length > 0 &&
                              ele?.subjectdata?.map((sub) => (
                                <th
                                  scope="col"
                                  style={{ width: "15%" }}
                                  key={`${sub.subject_id}-${ele.termid}`}
                                  className="text-capitalize"
                                >
                                  {sub?.subject}
                                </th>
                              ))}
                          </tr>
                        </thead>
                        <tbody>
                          {ele?.units?.length > 0 ? (
                            ele?.units
                              ?.slice(startIndex, endIndex)
                              ?.map((unit, unitIndex) => (
                                <React.Fragment
                                  key={`${unit?.unit_id}-${unitIndex}-${ele.termid}`}
                                >
                                  <tr>
                                    <td style={{ cursor: "pointer" }}>
                                      {unit?.name || "-"}
                                    </td>
                                    {ele?.subjectdata?.length > 0 &&
                                      ele?.subjectdata?.map((sub) => {
                                        const unitDataForSubject =
                                          unit.subjects?.find(
                                            (subject) =>
                                              subject.subject_id === sub.subject_id
                                          )?.units_json_data || [];
                                        return (
                                          <td
                                            key={`${unit.unit_id}-${sub.subject_id}-${unitIndex}-${ele.termid}`}
                                          >
                                            {unitDataForSubject?.length > 0
                                              ? unitDataForSubject
                                                ?.filter(
                                                  (jsonData) =>
                                                    !!jsonData?.abbreviation &&
                                                    !!jsonData?.tstm_guid
                                                )
                                                ?.map((jsonData, idx) => {
                                                  return (
                                                    <React.Fragment
                                                      key={`${unit.unit_id}-${sub.subject_id}-${unitIndex}-${idx}-${ele.termid}`}
                                                    >
                                                      <a
                                                        rel="noopener noreferrer"
                                                        style={{
                                                          marginRight: 5,
                                                          color: "red",
                                                          cursor: 'pointer'
                                                        }}
                                                        onClick={() => { onSubmit(jsonData?.tstm_guid) }}
                                                      >
                                                        {jsonData?.abbreviation}
                                                      </a>
                                                      {idx <
                                                        unitDataForSubject?.length -
                                                        1 && " | "}
                                                    </React.Fragment>
                                                  )
                                                }
                                                )
                                              : "-"}
                                          </td>
                                        );
                                      })}
                                  </tr>
                                </React.Fragment>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="6">-</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="pagin">
                      <Pagination
                        onPageChange={(page) =>
                          onPageChange(page, ele.courseid, ele.termid)
                        }
                        totalPages={Math.ceil(ele.data?.length / itemsPerPage)}
                        currentPage={currentPage}
                      />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        <div className="tbl_content">
          <ol type="1">
            <li>
              You can take the test ONLY ONCE during the available period.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Homework;